
export const MenuItems = [
    {
        title: 'About',
        url: `/#about`,
        cName: 'nav-links',
        name: 'about'
    },
    {
        title: 'MoU-I',
        url: `/mou-1#mou-1`,
        cName: 'nav-links',
        name: 'mou1',
    },
    // {
    //     title: 'Register',
    //     url: '/register#reg',
    //     cName: 'nav-links',
    //     name: 'register',
    // },
    {
        title: 'Attendees',
        url: '/attendees',
        cName: 'nav-links',
        name: 'attendees',
    },
    {
        title: 'Contact Us',
        url: '/#footer',
        cName: 'nav-links',
        name: 'contact',
    }
]